<template>
  <div>
    <img @click="openAlertModal" class="btn" :class="imageStyle" src="/suitcase.svg" width="20px">
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'company-suitcase',
  props: ['payload', 'imageStyle', 'additional_data'],
  computed: {
    initDesignator () {
      const type = this.payload.resource_type
      if (type == 'Position') return 'designated_position'
      if (type == 'Company') return 'follow_up_companies'
      return 'missions'
    }
  },
  methods: {
    openAlertModal () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        data: this.payload,
        init_designator: this.initDesignator,
        resource_type: this.payload.resource_type || this.additional_data.resource_type,
        resource_id: this.payload.resource_id || this.payload.id,
        modal_title: 'Create new Alert',
        ...(this.payload.resource_type == 'Position' && { suitcase: true }),
        ...(this.initDesignator == 'designated_position', { init_priority: 90 })
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
